// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"PopUp_Wrapper__1XvP4","Container":"PopUp_Container__hEDhO"};